import { render } from "./FilterQuotaDataByPeriodView.vue?vue&type=template&id=6767e790&scoped=true"
import script from "./FilterQuotaDataByPeriodView.vue?vue&type=script&lang=js"
export * from "./FilterQuotaDataByPeriodView.vue?vue&type=script&lang=js"

import "./FilterQuotaDataByPeriodView.vue?vue&type=style&index=0&id=6767e790&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6767e790"]])

export default __exports__